// src/app/store.ts
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import stepperSlice from '../features/stepper/stepperSlice';
import uploadSlice from '../features/upload/uploadSlice';
import userSlice from '../features/user/userSlice';
import returnAddressSlice from '../features/settings/returnAddressSlice';
import signatureSlice from '../features/settings/signatureSlice';
import courtLocationSlice from '../features/settings/courtLocationSlice';
import companySlice from '../features/company/companySlice';
import notificationsSlice from '../features/notifications/notificationsSlice';
import adminSlice from 'src/features/admin/adminSlice';

const settingsReducer = combineReducers({
  returnAddress: returnAddressSlice,
  signature: signatureSlice,
  courtLocation: courtLocationSlice,
});

export const store = configureStore({
  reducer: {
    stepper: stepperSlice,
    upload: uploadSlice,
    user: userSlice,
    settings: settingsReducer,
    company: companySlice,
    notifications: notificationsSlice,
    admin: adminSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['upload/setFocusedFileInStore', 'upload/addUploadedPdfs'],
        // Ignore all paths where non-serializable values like File objects might exist
        ignoredPaths: [
          'upload.focusedFile.baseBuffer', // Path for focusedFile
          'upload.focusedFile',
          'upload.uploadedPdfs.baseBuffer', // In case baseBuffer is nested
          'upload.uploadedPdfs', // Path for uploaded PDFs
        ],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
